module.exports = __webpack_public_path__ + "img/neutralnetworks_logo.f5659f20.svg";